<template>
    <div class="index-layout">
        <div class="panel white-bg">
            <webHeader></webHeader>
        </div>
        <div class="clearfix">
            <div class="center">
                <!-- <iframe v-if="url" name="body_iframe" id="body_iframe" :src="'http://localhost:8080'+url" frameborder="no" border="0" style="width:100%;height:100%"></iframe> -->
                <router-view v-if="reload"></router-view>
            </div>
        </div>
        <app-footer></app-footer>
        <div class="rightfix">
            <div class="wxbox">
                <el-popover placement="right" width="230" trigger="click">
                    <div style="text-align:center">
                        <img class="wxcodeImg" src="@static/images/wxcode.png" alt />
                        <p>扫一扫 关注凤栖云服公众号</p>
                        <p>保单查询 在线客服 极速理赔</p>
                    </div>
                    <div class="wxgzh" slot="reference">
                        <i class="iconfont icon-weixin2"></i>
                        <span>公众号</span>
                    </div>
                </el-popover>
                <el-popover placement="right" width="230" trigger="click">
                    <div style="text-align:center">
                        <img class="wxcodeImg" src="@static/images/appcode.png" alt />
                        <p>扫一扫 下载凤栖云服APP</p>
                    </div>
                    <div class="wxgzh" slot="reference">
                        <i class="iconfont icon-app2"></i>
                        <span>APP</span>
                    </div>
                </el-popover>
            </div>
        </div>
    </div>
</template>
<script>
//当前实例组件
var QRCode = require("qrcode");
import commom from "../../api/common";
import footer from '@/components/footer'
import webHeader from "@/components/webHeader";
export default {
    data: () => ({
        checked: true,
        mechanUser:{},
        url: "", //当前地址
        id: "", //当前id
        reload: true,
        wxcodeImg: "",
        name: "",
        menu: [],
        level: ""
    }),
    components: {"app-footer":footer,webHeader},
    created() {
      this.setUserInfo();
    },
    methods: {
        tostr: function(num) {
            return num.toString();
        },
        gonn: function() {
            var rou = this.$router.resolve("/new_notice");
            window.open(rou.href, "_blank");
        },
        goHelp: function() {
            this.$router.push("/help/index");
        },
        goIndex: function() {
            //跳转到首页
            this.$router.push("/index_content");
        },
        handleCommand(e) {
            //顶部下拉框选择回调
            this.$notice.msg(e);
        },
        handleSelect(e) {
            //侧边栏选择回调
            var that = this;
            if (that.$tools.getLocal("userinfo")) {
                let e1 = e.split("?")[0];
                let url1 = this.url.split("?")[0];
                if (e1 == url1) {
                    e = e.replace("/#", "");
                    // that.$router.replace(e);
                    that.$router.push(e);
                    that.reload = false;
                    setInterval(function() {
                        that.reload = true;
                    }, 100);
                } else {
                    that.url = e;
                    e = e.replace("/#", "");
                    that.$router.push(e);
                    //  that.reload=false;
                    //  setInterval(function(){
                    //   that.reload=true;
                    // },100)
                }
            } else {
                this.$router.push("/login");
                this.$notice.msg("请重新登录", 2, 1500);
            }
        },
        out: function(e) {
            if (e != 10) {
                this.handleSelect(e);
            } else {
                this.loginOut();
                localStorage.removeItem('userinfo')
                localStorage.removeItem('all')
                localStorage.removeItem('queryMechanInfo')
                // this.$tools.setLocal("userinfo", "");
                this.$router.push("/");
            }
        },
        loginOut: function() {
            this.$http({
                url: '/master/user/logout',
                type: 'get',
                params: {}
            });
        },
        queryMenu: function() {
            var that = this;
            this.$http({
                url: '/master/mechanIndex/queryMenu',
                type: 'put',
                params: {}
            }).then(function(data) {
                that.menu = data.data;
            });
        },
        // 获取计划书链接
        getPlanUrl() {
          this.$http({
            url: "/master/subscribeService/getPlanUrl",
            type: "put",
            params: {},
          }).then((res) => {
            var canvas = document.getElementById("planCan");
            QRCode.toCanvas(canvas, res.data, function (error) {
              if (error) console.error(error);
              console.log("success!");
            });
          });
        },
        setUserInfo(){
          const data = this.$tools.getLocal("userinfo");
          this.wxcodeImg = data.wechatImgUrl;
          this.name = data.name;
          this.level = data.level;
          this.mechanUser = data;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "~@/sass/pages/index";
.el-submenu__title {
    img {
        margin-right: 5px;
        width: 24px;
    }
}
.agree2 {
    padding: 50px 0 30px 0;
    text-align: center;
    color: #000;
    font-size: 14px;
}
.agree2 a {
    color: #000;
}
.icon-yeji {
    font-size: 20px;
    margin-left: -2px;
}
.index-layout {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 60px;
    .panel {
        &.white-bg {
            background-color: #fff;
        }
        &.gray-bg {
            background-color: #F0F1F4;
        }
    }
    header {
        width: 1200px;
        margin: auto;
        position: static;
        padding: 0;
    }
}
</style>
